/* istanbul ignore file */

import { ReactionListParams, ReactionResourceRef } from './types';
/**
 * Generic reactions query keys (independent of v1 or v2)
 */
export const reactionsQueryKeys = {
    listReactions: ({ resourceType, resourceId }: ReactionResourceRef, pageParams?: ReactionListParams) => [
        'reactions',
        'list-reactions',
        resourceType,
        resourceId,
        pageParams,
    ],
    reactionStatus: ({ resourceType, resourceId }: ReactionResourceRef) => [
        'reactions',
        'reaction-status',
        resourceType,
        resourceId,
    ],
};
